var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 2.99996H11.7501V1.49998C11.7501 1.10216 11.5921 0.720635 11.3108 0.439334C11.0295 0.158033 10.6479 0 10.2501 0L5.75017 0C5.35235 0 4.97083 0.158033 4.68953 0.439334C4.40823 0.720635 4.25019 1.10216 4.25019 1.49998V2.99996H0.500244V4.49994H2.00022V15.7498C2.00022 16.3465 2.23727 16.9188 2.65922 17.3408C3.08118 17.7627 3.65346 17.9998 4.25019 17.9998H11.7501C12.3468 17.9998 12.9191 17.7627 13.3411 17.3408C13.763 16.9188 14.0001 16.3465 14.0001 15.7498V4.49994H15.5V2.99996ZM5.75017 1.49998H10.2501V2.99996H5.75017V1.49998ZM12.5001 15.7498C12.5001 15.9487 12.4211 16.1395 12.2804 16.2801C12.1398 16.4208 11.949 16.4998 11.7501 16.4998H4.25019C4.05128 16.4998 3.86052 16.4208 3.71987 16.2801C3.57922 16.1395 3.5002 15.9487 3.5002 15.7498V4.49994H12.5001V15.7498Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.24998 7.49951H5.75V13.4994H7.24998V7.49951Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.2502 7.49951H8.75024V13.4994H10.2502V7.49951Z",
    fill: "#57689F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDoc);
export default __webpack_public_path__ + "static/media/delete_doc.be7c6e0be66761a21226c6499a99a946.svg";
export { ForwardRef as ReactComponent };